<template>
    <div class="settings-layout details-layout">
        <div class="form-section">
            <div class="plan-confirm-wrap">
                <div class="plan-confirm-container">
                    <div class="plan-onceoff-logo">
                        <img src="https://cdn.visily.ai/images/91ed48f2-3f49-453d-aff5-004c783e9fff/6678/7fbba61f-91e8-40ec-be96-e51011d3797c.png" />
                    </div>
                    <div class="plan-onceoff-tite">
                        <div class="title-text">Gold Partner</div>
                        <div class="onceoff-fee">Joinig fee once-off</div>
                    </div>
                    <div class="plan-price">
                        <div id="original-joining-fee">{{ formData.selectedPlan.currency.code_symbol }}{{ parseFloat(formData.originalJoiningFee).toFixed(formData.selectedPlan.currency.decimal_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") }}</div>
                        <div id="discounted-joining-fee">{{ formData.selectedPlan.currency.code_symbol }}{{ parseFloat(joiningFee).toFixed(formData.selectedPlan.currency.decimal_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") }}</div>
                    </div> 
                </div>
                <div class="plan-confirm-container">
                    <div class="plan-onceoff-logo">
                        <img src="https://cdn.visily.ai/images/91ed48f2-3f49-453d-aff5-004c783e9fff/6678/4d6d3799-c5a4-47ac-b52a-c248fc66cdf3.png" />
                    </div>
                    <div class="plan-onceoff-tite">
                        <div class="title-text">Membership Fee</div>
                        <div class="onceoff-fee" id="original-plan-start-date">{{ formData.yearlyPlan ? 'Yearly' : 'Montlhy' }} (beginning {{ formData.planStartDateDisplay }})</div>
                    </div>
                    <div class="plan-price">
                        <div id="original-plan-fee">{{ formData.selectedPlan.currency.code_symbol }}{{ parseFloat(formData.originalPlanFee).toFixed(formData.selectedPlan.currency.decimal_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") }}</div>
                        <div id="discounted-plan-fee">{{ formData.selectedPlan.currency.code_symbol }}{{ parseFloat(planFee).toFixed(formData.selectedPlan.currency.decimal_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") }}</div>
                    </div> 
                </div>
                <div class="plan-confirm-container" style="padding-bottom: 0px;">
                    <div class="plan-voucher">
                        <div class="plan-voucher-title">VOUCHER</div>
                        <div class="plan-voucher-form">
                            <div class="input-fileds">
                                <input type="text" id="voucher_code" placeholder="Enter voucher code">
                            </div>
                            <div class="input-button">
                                <button class="plan-voucher-button" id="apply-clear-voucher" @click="checkVoucherCode">Apply</button>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div id="subscription-voucher-desc"></div>
                <div class="plan-confirm-container">
                    <div class="total-payment">
                        <div class="total-payment-title">TOTAL DUE NOW</div>
                        <div class="total-payment-price">
                            {{ formData.selectedPlan.currency.code_symbol }}{{ chargePlanFeeNow == "false" ? parseFloat(formData.joiningFee).toFixed(formData.selectedPlan.currency.decimal_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : sumJoiningAndSubscription }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br>
    <div class="settings-layout details-layout">
        <form @input="submit">
            <div class="form-section payment-option hidden">
                <div class="w-80">
                    <div class="form-group w-100">
                        <div class="payment-method-wrap">
                            <div><label>Pay with</label></div>
                            <div class="option-wrap checkout-page ui buttons big display-left w-40">
                                <button type="button" 
                                    class="ui button toggle"
                                    @click="togglePaymentMethod(); submit()"
                                    :class="[cc ? 'active' : '']"
                                >Credit Card</button>
                                <button type="button"  
                                    class="ui button toggle"
                                    @click="togglePaymentMethod(); submit()"
                                    :class="[!cc ? 'active' : '']"
                                >Bank Account</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section" v-show="this.cc">
                <div class="form-group w-80">
                    <label>CARD HOLDER</label>
                    <div class="input-group-cover">
                       <input type="text" @input="submit" v-model="cardHolder" placeholder="Card holder" name="cardHolder" id="cardHolder" @blur="v$.cardHolder.$touch()">
                       <FormError :validationStatus="v$.cardHolder"/>
                    </div>
                </div>

                <keep-alive>
                    <CardStripe 
                        :countryCode="formData.countryCode" 
                        :storeName="formData.storeName"
                        :stripeKeyString="formData.stripeKeyString"
                        :freeTrial="freeTrial"
                        :joiningFee="formData.joiningFee"
                        :discountRemainingCycle="discountRemainingCycle"
                        :planFee="formData.planFee"
                        :planStartDate="formData.planStartDate"
                        :planEndDate="formData.planEndDate"
                        :chargePlanFeeNow="chargePlanFeeNow"
                        :voucherCodeId="this.voucherCodeId"
                    />
                </keep-alive>
            </div>

            <div class="form-section" v-if="!this.cc">
                <div class="w-flex-80">
                    <div class="form-group">
                        <label>ACCOUNT NAME</label>
                        <div class="input-group-cover">
                            <input type="text" @input="submit" placeholder="Account name" name="account_name" id="account_name" v-model="accountName" @blur="v$.cardHolder.$touch()">
                        </div>
                    </div>

                    <div class="form-group" style="margin-left: 2%;">
                        <label>BSB</label>
                        <div class="input-group-cover">
                            <input type="text" @input="submit" placeholder="BSB" name="bsb" id="bsb"  v-model="bsb" @blur="v$.bsb.$touch()">
                        </div>
                    </div>
                </div>
                
                <div class="w-flex-80">
                    <div class="form-group">
                        <label>ACCOUNT NUMBER</label>
                        <div class="input-group-cover">
                            <input type="text" @input="submit" placeholder="Account number" name="account_number" id="account_number" v-model="accountNumber" @blur="v$.accountNumber.$touch()">
                        </div>
                    </div>

                    <div class="form-group" style="margin-left: 2%;">
                        <label>CONFIRM ACCOUNT NUMBER</label>
                        <div class="input-group-cover">
                            <input type="text" @input="submit" placeholder="Account number" name="confirm_account_number" id="confirm_account_number"  v-model="confirmAccountNumber" @blur="v$.confirmAccountNumber.$touch()">
                        </div>
                    </div>
                </div>

                <div class="w-80">
                    <div class="form-group w-80">
                        <input id="check-agree" type="checkbox"/> <label for="check-agree"> I agree to the terms and conditions of the <a target="_blanke" href="https://home.thelittapp.com/wp-content/uploads/2024/01/LITT-Global-Partner-Agreement-2024.pdf">LITT Reward Partner Agreement</a>. </label>
                    </div>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
import FormError from '../../FormError.vue';
import { required, minLength, maxLength, numeric } from '@vuelidate/validators';
import CardStripe from './CardStripe.vue';
import useVuelidate from '@vuelidate/core';
import moment from 'moment';
import axios from "axios";
import $ from 'jquery';

export default {
    inject: ['submitForm'],
    setup(){
        return { v$: useVuelidate() }
    },
    name: "Checkout",
    props: ['formData', 'byCreditCard'],
    components: {FormError, moment, CardStripe},
    data(){
        return{
            discounted: false,
            freeTrial: 0,
            voucherCodeId: "",
            discountRemainingCycle: 0,
            joiningFee: this.formData.joiningFee,
            planFee: this.formData.planFee,
            planStartDateDisplay: this.formData.originalPlanStartDateDisplay,
            planStartDate: this.formData.originalPlanStartDate,
            planEndDate: this.formData.originalPlanEndDate,
            chargePlanFeeNow: "true",
            cardHolder: "",
            cardNumber: "",
            cardExpiry: "",
            cardCVV: "",
            bsb: "",
            accountNo: "",
            cc: true,
            accountName: "",
            confirmAccountNumber: "",
            countryCode: this.formData.countryCode
        }
    },
    methods:{
        moment: function () {
            return moment();
        },
        submit(){
            this.$emit('update', {
                data:{
                    cardHolder: this.cardHolder,
                    cardNumber: this.cardNumber,
                    cardExpiry: this.cardExpiry,
                    cardCVV: this.cardCVV,
                    byCreditCard: this.cc,
                    accountName: this.accountName,
                    bsb: this.bsb,
                    accountNo: this.accountNo,
                    confirmAccountNumber: this.confirmAccountNumber,
                    joiningFee: this.joiningFee,
                    planFee: this.planFee,
                    planStartDateDisplay: this.planStartDateDisplay,
                    planStartDate: this.planStartDate,
                    planEndDate: this.planEndDate
                },
                valid: !this.v$.$invalid
            })
        },
        togglePaymentMethod(){
            this.cc = !this.cc;
        },
        checkVoucherCode(){
            $("#showRunning").trigger("click");
            
            if (this.discounted) {  // do not use voucher instead
                $("#apply-clear-voucher").text('Apply');

                this.freeTrial = 0;
                this.discountRemainingCycle = 0;
                this.voucherCodeId="";

                this.joiningFee = this.formData.originalJoiningFee;
                this.planFee = this.formData.originalPlanFee;
                this.planStartDateDisplay = this.formData.originalPlanStartDateDisplay;
                this.planStartDate = this.formData.originalPlanStartDate;
                this.planEndDate = this.formData.originalPlanEndDate;

                if (moment(this.planStartDate).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')) {
                    this.chargePlanFeeNow = "true";
                } else {
                    this.chargePlanFeeNow = "false";
                }
                $('#original-joining-fee').css('text-decoration', '');
                $('#original-plan-fee').css('text-decoration', '');
                $("#discounted-joining-fee").css("display", "none");
                $("#discounted-plan-fee").css("display", "none");

                this.discounted = false;
                $("#subscription-voucher-desc").html("");
                $("#voucher_code").html("");

                $("#voucher_code").css('background-color', '#ffffff');
                $("#voucher_code").removeAttr('readonly');

                $('#original-plan-start-date').css('text-decoration', '');
                $('#discounted-plan-start-date').css('display', 'none');
                
                this.submit();

                $("#hideRunning").trigger("click");
            } else {                // checked voucher code for once only (if it's a valid one)
                axios.post('check-subscription-voucher',{
                    'voucher_code': $("#voucher_code").val()
                }).catch((error)=>{
                    console.log("Failed to check voucher code \r\n" + error);
                    $("#subscription-voucher-desc").html("Got an error to verify the code");
                    return false;
                }).then((result)=>{
                    $("#hideRunning").trigger("click");
                    if (result.data.status == 'true' && result.data.voucher != null) {

                        this.voucherCodeId = result.data.voucher.id;

                        if (result.data.voucher.free_trial_period == 0 && result.data.voucher.discount_amount == 0) {
                            $("#subscription-voucher-desc").html("No deal found! Try another code please.");
                            return false;
                        }

                        $("#subscription-voucher-desc").html(result.data.voucher.description);

                        // free trial
                        if ( result.data.voucher.free_trial_period > 0) {
                            this.freeTrial = result.data.voucher.free_trial_period;
                            this.chargePlanFeeNow = "false";

                            let freeTrialPeriodInDays = result.data.voucher.free_trial_period; 
                            
                            switch (result.data.voucher.free_trial_period_unit) {
                                case 'Year':
                                    freeTrialPeriodInDays *= 365;
                                    break;
                                case 'Month':
                                    freeTrialPeriodInDays *= 30;
                                    break;
                                case 'Fortnight':
                                    freeTrialPeriodInDays *=14;
                                    break;
                                case 'Week':
                                    freeTrialPeriodInDays *= 7;
                                    break;
                            }

                            this.planStartDateDisplay = moment().add(freeTrialPeriodInDays, 'd').format('D MMM YYYY');
                            this.planStartDate = moment().add(freeTrialPeriodInDays, 'd').format('YYYY-MM-DD HH:mm:ss');
                            this.planEndDate = moment(this.formData.originalPlanEndDate, 'YYYY-MM-DD HH:mm:ss').add(freeTrialPeriodInDays, 'd').format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            this.planStartDateDisplay = moment().format('D MMM YYYY');
                            this.planStartDate = moment().format('YYYY-MM-DD HH:mm:ss');
                            this.planEndDate = moment().add(1, this.formData.selectedPlanId.billing_cycle == 'Yearly' ? 'y' : 'M').format('YYYY-MM-DD HH:mm:ss');
                        }

                        // joining/plan fee discount
                        if ( result.data.voucher.discount_amount > 0 ) {
                            this.discountRemainingCycle = result.data.voucher.discount_period;

                            switch (result.data.voucher.discount_target) {
                                case 'Joining':
                                    if (result.data.voucher.discount_amount_type == 'Sum') {
                                        this.joiningFee = this.formData.originalJoiningFee - result.data.voucher.discount_amount;
                                    } else {    // Percentage
                                        this.joiningFee = this.formData.originalJoiningFee * (1-result.data.voucher.discount_amount * 0.01);
                                    }
                                    $('#original-joining-fee').css('text-decoration', 'line-through');
                                    $('#discounted-joining-fee').css('display', 'block');
                                    break;
                                case 'Subscription':
                                    if (result.data.voucher.discount_amount_type == 'Sum') {
                                        this.planFee = this.formData.originalPlanFee - result.data.voucher.discount_amount;
                                    } else {    // Percentage
                                        this.planFee = this.formData.originalPlanFee * (1-result.data.voucher.discount_amount * 0.01);
                                    }
                                    
                                    $('#original-plan-fee').css('text-decoration', 'line-through');
                                    $("#discounted-plan-fee").css('display', 'block');
                                    break;
                                case 'Both':
                                    if (result.data.voucher.discount_amount_type == 'Sum') {
                                        this.joiningFee = this.formData.originalJoiningFee - result.data.voucher.discount_amount;
                                        this.planFee = this.formData.originalPlanFee - result.data.voucher.discount_amount;
                                    } else {
                                        this.joiningFee = this.formData.originalJoiningFee * (1-result.data.voucher.discount_amount * 0.01);
                                        this.planFee = this.formData.originalPlanFee * (1-result.data.voucher.discount_amount * 0.01);
                                    }
                                    
                                    $('#original-joining-fee').css('text-decoration', 'line-through');
                                    $('#original-plan-fee').css('text-decoration', 'line-through');
                                    $("#discounted-joining-fee").css('display', 'block');
                                    $("#discounted-plan-fee").css('display', 'block');
                                    break;
                            }
 
                        }

                        this.joiningFee=parseFloat(this.joiningFee).toFixed(this.formData.selectedPlan.currency.decimal_digits);
                        this.planFee=parseFloat(this.planFee).toFixed(this.formData.selectedPlan.currency.decimal_digits);

                        // minimum is 0
                        this.joiningFee = this.joiningFee > 0 ? this.joiningFee : 0;
                        this.planFee = this.planFee > 0 ? this.planFee : 0;

                        this.submit();

                        this.discounted = true;

                        $("#apply-clear-voucher").text('Clear');
                        $("#voucher_code").css('background-color', '#C2C2C2');
                        $("#voucher_code").prop('readonly', 'true');

                    } else {
                        if (result.data.status == 'false' && result.data.errors)
                            $("#subscription-voucher-desc").html(result.data.errors);
                        else
                            $("#subscription-voucher-desc").html("Invalid voucher code");
                    }
                });
            }
        }
    },
    computed:{
        sumJoiningAndSubscription() { 
            return parseFloat(parseFloat(parseFloat(this.joiningFee).toFixed(this.formData.selectedPlan.currency.decimal_digits)) + parseFloat(parseFloat(this.planFee).toFixed(this.formData.selectedPlan.currency.decimal_digits))).toFixed(this.formData.selectedPlan.currency.decimal_digits).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    mounted() {
        this.submit();
        this.submitForm();

        if (moment(this.planStartDate).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')) {
            this.chargePlanFeeNow = "true";
        } else {
            this.chargePlanFeeNow = "false";
        }
    },
    validations:{
        cardHolder: {required, minLength: minLength(2)},
        // bsb: {required, numeric, only6Digits},
        // accountNo: {required, numeric, minLength: minLength(8), maxLength: maxLength(10)},
    }
}
</script>